import { t } from '../../../shared/config/translations'

export function shufflePageTemplate(): string {
	return `
        <div id="shuffle-section">
            <header class="shuffle-page-header">
                <h1>${t('shuffle.findNextSpin')}</h1>
            </header>
            <p class="btn count is-loading" data-shuffle-match-count aria-busy="true" aria-live="polite">
                <svg aria-hidden="true"><use href="#symbols-collection"></use></svg>
                <span class="loading-placeholder"></span>
            </p>
            <form id="shuffle-form">
                <section class="shuffle-filter-card" aria-label="${t('collection.filters')}">
                    <div id="filter-container" class="filter-stack"></div>
                    <div class="shuffle-filter-actions">
                        <button
                            type="button"
                            class="btn secondary small"
                            data-save-shuffle-defaults
                        >
                            ${t('common.saveAsDefault')}
                        </button>
                        <button
                            type="button"
                            class="btn secondary small"
                            data-reset-shuffle-filters
                        >
                            ${t('common.resetToDefault')}
                        </button>
                    </div>
                </section>
                <button id="shuffle-button" class="button-82-pushable" role="button" type="submit" disabled>
                    <span class="button-82-shadow"></span>
                    <span class="button-82-edge"></span>
                    <span class="button-82-front text">
                        <svg><use href="#symbols-shuffle"></use></svg>
                        <div class="shuffle-submit-label">${t('shuffle.shuffle')}</div>
                    </span>
                </button>
            </form>
        </div>
    `
}
